import { SystemUserImpl } from "../data/SystemUserImpl";
import { ISystemUserRepository } from "../domain/repositories/ISystemUserRepository";
import { SystemUserUseCase } from "../domain/useCases/SystemUserUseCase";
import { SystemUserViewModel } from "../presentation/viewModel/SystemUserViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class SystemUserInjection extends InjectionModule {
  private static readonly systemUserRepositoryToken = Symbol(
    "ISystemUserRepository",
  );
  private static readonly systemUserUseCaseToken = Symbol("SystemUserUseCase");
  private static readonly systemUserViewModelToken = Symbol(
    "SystemUserViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.systemUserRepositoryToken,
      useClass: SystemUserImpl,
    },
    {
      scope: "otherRepo",
      token: this.systemUserUseCaseToken,
      useClass: SystemUserUseCase,
    },
    {
      scope: "viewModel",
      token: this.systemUserViewModelToken,
      useClass: SystemUserViewModel,
    },
  ];

  static getRepo(): ISystemUserRepository {
    return this.resolve(this.systemUserRepositoryToken);
  }

  static getUseCase(): SystemUserUseCase {
    return this.resolve(this.systemUserUseCaseToken);
  }
}
